// Modules
import React from 'react'

// Components
import { TemplateABTest } from 'redesign/components/templates'
import { Wrapper, Title, Subtitle } from './styles'

// Application
import { useCurrentLaboratory } from 'redesign/hooks/useCurrentLaboratory'
import { useCPFLoginForm } from 'redesign/hooks/useCPFLoginForm'
import { CPFPhasedLoginForm } from '../CPFPhasedLoginForm'

export const CustomNewLogin = () => {
    const { title, subTitle } = useCurrentLaboratory()
    const { isAuthServiceDown } = useCPFLoginForm()
    const { isServiceDown } = isAuthServiceDown()

    return (
        <TemplateABTest>
            <Wrapper>
                <Title>{title}</Title>
                <Subtitle dangerouslySetInnerHTML={{ __html: subTitle }} />
            </Wrapper>
            <CPFPhasedLoginForm isServiceDown={isServiceDown} />
        </TemplateABTest>
    )
}
